import { Injectable } from "@angular/core";
import { ApiService } from "../../../services/api/api.service";
import {forkJoin, map, Observable} from "rxjs";
import { GroupDataDto, GroupDeleteDataDto, PercentDataPosDto, VirtualCashListModelsDto, VirtualCashModelsDto } from "../models/virtual-cash.models";
import { UserInfoService } from "../../../services/user-info.service";
import { SortTableService } from "../../../services/sort-table.service";
import { FilterSearchResultDto } from "src/app/models/filter.model";

@Injectable({
	providedIn: "root",
})
export class VirtualCashDataService {
	agentId: string | undefined;
	userId: number | undefined;

	sort: string | undefined;

	constructor(
		private apiService: ApiService,
		private userInfoService: UserInfoService,
		private sortTableService: SortTableService
	) {
		this.userInfoService.userId$.subscribe({
			next: (res) => {
				this.userId = res;
			},
		});

		this.userInfoService.agentId$.subscribe({
			next: (res) => {
				this.agentId = res;
			},
		});

		this.sortTableService.sortColum$.subscribe({
			next: (res) => {
				this.sort = res;
			},
		});
	}

	loadVirtualCashFilter(): Observable<any> {
		const url = `/agents/${this.agentId}/virtual_pos/filter`;
		return this.apiService.httpGet<any>(url);
	}

	loadVirtualCashList(page: number, search: string | undefined = "", data?: any): Observable<VirtualCashListModelsDto> {
		const url = `/agents/${this.agentId}/virtual_pos/filter?page_number=${page}&per_page=20&${this.sort}&search=${search}`;
		return this.apiService.httpPost<VirtualCashListModelsDto>(url, data);
	}

	loadSearchList(data: any): Observable<FilterSearchResultDto> {
		const url = `/agents/${this.agentId}/virtual_pos/filter/list?page_number=0&per_page=10`;
		return this.apiService.httpPost<FilterSearchResultDto>(url, data);
	}

	loadDetailVirtualCash(id: number): Observable<VirtualCashModelsDto> {
		const url = `/agents/${this.agentId}/virtual_pos/${id}`;
		return this.apiService.httpGet<VirtualCashModelsDto>(url);
	}

	changeStatus(id: number, state: boolean): Observable<void> {
		const url = `/agents/${this.agentId}/virtual_pos/${id}?is_blocked=${state}`;
		return this.apiService.httpPatch<void>(url);
	}

	deleteVirtualCash(id: number): Observable<void> {
		const url = `/agents/${this.agentId}/virtual_pos/${id}`;
		return this.apiService.httpDelete<void>(url);
	}

	loadCommissionData(id: number): Observable<PercentDataPosDto[]> {
		const url = `/reference/virtual_pos/${id}/commission_settings`;
		return this.apiService.httpGet<PercentDataPosDto[]>(url);
	}

	updateVirtualCash(id: number, body: VirtualCashModelsDto): Observable<void> {
		const url = `/agents/${this.agentId}/virtual_pos/${id}`;
		return this.apiService.httpPut<void>(url, body);
	}

	groupBlockedCash(data: GroupDataDto): Observable<void> {
		const url = `/agents/${this.agentId}/virtual_pos/change_status_list?is_blocked=true`;
		return this.apiService.httpPatchGroup<void>(url, data);
	}

	groupUnlockedCash(data: GroupDataDto): Observable<void> {
		const url = `/agents/${this.agentId}/virtual_pos/change_status_list?is_blocked=false`;
		return this.apiService.httpPatchGroup<void>(url, data);
	}

  groupDeleteCash(data: { vpIdList: number[] }): Observable<void> {
    const calls = data.vpIdList.map(id =>
      this.deleteVirtualCash(id)
    );
    return forkJoin(calls).pipe(map(() => void 0));
  }
}
